
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/jobs/create",
      function () {
        return require("private-next-pages/page/jobs/create/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/page/jobs/create"])
      });
    }
  